export default {
    list: {
        title: "Containers",
        subtitle: "Manage your shipping containers",
        newContainer: "New Container",
        viewMap: "View Map",
        loading: "Loading containers...",
        clearFilters: "Clear Filters",
        backToDashboard: "Back to Dashboard",
        filters: {
            searchPlaceholder: "Search by container number, route...",
            statusPlaceholder: "Filter by status",
            riskLevelPlaceholder: "Filter by risk level",
            documentStatusPlaceholder: "Filter by document status",
            docStatusPlaceholder: "Document Status",
            shippingCompanyPlaceholder: "Filter by shipping company",
            commodityPlaceholder: "Filter by commodity",
            originPlaceholder: "Filter by origin",
            portPlaceholder: "Filter by arrival port",
            timeRangePlaceholder: "Time Period",
            allStatuses: "All Statuses",
            allLevels: "All risk levels",
            allDocStatuses: "All document statuses",
            allCompanies: "All companies",
            allCommodities: "All commodities",
            allOrigins: "All origins",
            allPorts: "All ports",
            docIssuesLabel: "Doc issues",
            docIssuesHelper: "Show only containers with document-related issues: missing, non-compliant or documents to verify.",
            docIssuesInfoAria: "Explain Doc issues filter",
            activeAlertsLabel: "Alerts",
            activeAlertsHelper: "Show only containers with active alerts: delays, temperature, customs hold, etc.",
            activeAlertsInfoAria: "Explain Alerts filter",
        },
        docStatus: {
            pending: "Pending Documents",
            complete: "Documents Complete",
        },
        timeRange: {
            currentMonth: "Current month",
            lastMonth: "Last month",
            last3Months: "Last 3 months",
            last6Months: "Last 6 months",
            last9Months: "Last 9 months",
            lastYear: "Last year",
        },
        table: {
            title: "Containers",
            description: "Complete list of containers",
            updating: "Updating...",
            headers: {
                containerNumber: "Container Reference",
                route: "Route",
                progress: "Progress",
                status: "Status",
                documentStatus: "Documents",
                riskLevel: "Risk",
                value: "Value",
                createdAt: "Created",
                actions: "Actions",
                carrier: "Carrier",
                receiver: "Receiver",
                etd: "ETD",
                eta: "ETA",
                documents: "Documents",
                docStatus: "Doc Status",
                extraDocIssues: "Extra-Doc Issues",
                lastUpdate: "Last Update",
                bookingNo: "Booking #",
                blNo: "B/L #",
                valueUsd: "Value (USD)",
                product: "Product",
                qtyWeight: "Qty/Weight",
                tempC: "Temp (°C)",
                actualTd: "Actual TD",
                delayDays: "Delay Days",
                originPort: "Origin Port",
                destPort: "Dest Port",
                paymentTerms: "Payment Terms",
                freightTerms: "Freight Terms",
            },
            view: "View",
            edit: "Edit",
            delete: "Delete",
            noContainers: {
                title: "No containers found",
                message: "Try modifying the search filters",
                emptyMessage: "Start by creating your first container",
                createFirst: "Create the first container",
            },
        },
        charts: {
            riskLevels: "Risk Level",
            containerStatus: "Container Status",
            documentStatus: "Document Parsing Status",
        },
        spreadsheet: {
            noDocuments: "No documents",
            allDocsOk: "All docs OK",
            issuesInDocs: "{{count}} issues in docs",
            noIssues: "No issues",
            issueCount: "{{count}} issues",
            comingSoon: "Coming soon",
            fewerColumns: "Fewer columns",
            moreColumns: "More columns",
            export: "Export",
            excelXlsx: "Excel (.xlsx)",
            csvFile: "CSV (.csv)",
            ofTotal: "{{current}} of {{total}}",
        },
        expandedDetails: {
            hideDetails: "Hide details",
            bookingNumber: "Booking Number",
            poNumber: "PO Number",
            vessel: "Vessel",
            voyage: "Voyage",
            consignee: "Consignee",
            incoterms: "Incoterms",
            transportMode: "Transport Mode",
            cargoType: "Cargo Type",
            hazardousMaterial: "Hazardous Material",
            hazardousYes: "Yes ({{hazClass}})",
            hazardousNo: "No",
            weightKg: "Weight (kg)",
            volumeCbm: "Volume (cbm)",
            packages: "Packages",
            totalValue: "Total Value",
            freightCost: "Freight Cost",
            insurance: "Insurance",
            hsCode: "HS Code",
            progress: "Progress",
            bookingDate: "Booking Date",
            departure: "Departure",
            created: "Created",
            documentStatus: "Document Status",
            systemStatus: "System Status",
            trackingProvider: "Tracking Provider",
            lastTracked: "Last Tracked",
            activeAlerts: "Active Alerts",
            alertsYes: "Yes ({{count}})",
            alertsNo: "No",
            temperature: "Temperature",
            viewEmails: "View emails",
            viewDocuments: "View documents",
        },
    },
    form: {
        title: "New Container",
        editTitle: "Edit Container",
        subtitle: "Create a new shipping container",
        editSubtitle: "Edit container details",
        loading: "Loading container...",
        back: "Back",
        sections: {
            containerInfo: "Container Information",
            route: "Route",
            order: "Order",
            receiver: "Receiver",
            value: "Value",
            vesselInfo: "Vessel & Booking",
        },
        fields: {
            bookingNumber: "Booking Number",
            bookingNumberPlaceholder: "EVE2025-001234",
            containerNumber: "Container Number",
            containerNumberPlaceholder: "MAEU1234567",
            blNumber: "Bill of Lading",
            blNumberPlaceholder: "BL123456789",
            status: "Status",
            statusPlaceholder: "Select status",
            physicalStatus: "Physical Status",
            physicalStatusPlaceholder: "Select physical status",
            routeFrom: "From",
            routeFromPlaceholder: "New York, USA",
            routeTo: "To",
            routeToPlaceholder: "London, UK",
            eta: "ETA",
            shippingCompany: "Shipping Company",
            shippingCompanyPlaceholder: "Select company",
            receiver: "Receiver",
            receiverPlaceholder: "Select receiver",
            amount: "Amount",
            amountPlaceholder: "125000",
            currency: "Currency",
            currencyPlaceholder: "Select currency",
            orderId: "Order ID",
            orderIdPlaceholder: "Enter or select Order ID",
            orderIdSelectExisting: "Select from existing orders",
            orderIdEnterManually: "Enter manually",
            vesselName: "Vessel Name",
            vesselNamePlaceholder: "Enter vessel name",
            voyageNumber: "Voyage Number",
            voyageNumberPlaceholder: "Enter voyage number",
        },
        actions: {
            cancel: "Cancel",
            save: "Save Changes",
            create: "Create Container",
        },
        errors: {
            generic: "An error occurred while saving the container",
            allFieldsRequired: "All fields are required",
            amountInvalid: "Amount must be a number greater than 0",
            containerExists: "A container with this number already exists",
            containerNumberRequired: "Container number is required",
            bookingNumberRequired: "Booking number is required",
        },
        updateSuccess: "Container updated successfully",
        updateError: "Failed to update container",
        loadError: "Failed to load container data",
        backToList: "Back to Containers",
        containerNumberReadonly: "Container number cannot be changed",
        bookingNumberReadonly: "Booking number cannot be changed",
        bookingNumberHint: "Carrier booking reference number",
        containerNumberHint: "ISO container number (optional - assigned by carrier)",
        blNumberHint: "Required for carrier tracking",
        noReceivers: "No active receivers available. Invite a new receiver to continue.",
        selectReceiver: "Select Receiver",
        notesOptional: "Notes (optional)",
        notesPlaceholder: "Add a note for the receiver...",
        selectedReceiver: "Selected Receiver",
        name: "Name",
        email: "Email",
        country: "Country",
        sendInvite: "Send Invite",
    },
    detail: {
        back: "Back to Containers",
        backToList: "Back to list",
        loading: "Loading container details...",
        notFound: {
            title: "Container not found",
            message: "The requested container does not exist or you do not have permission to view it.",
        },
        actions: {
            uploadDocuments: "Upload Documents",
            triage: "Triage",
            edit: "Edit",
            share: "Share",
            archive: "Archive",
            delete: "Delete",
            actions: "Actions",
            availableActions: "Available Actions",
            comingSoon: "Coming soon",
            addNote: "Add Note",
            addNoteDesc: "Add internal or customer notes",
            evaluateDocs: "Evaluate Documents",
            evaluateDocsDesc: "AI cross-check for discrepancies",
            refreshTracking: "Refresh Tracking",
            reportIssue: "Report Issue",
            reportIssueDesc: "Report a problem with this container",
            viewRisk: "Risk Assessment",
            viewRiskDesc: "View detailed risk analysis",
            noRiskData: "No Risk Data Available",
            noRiskDataDesc: "Risk assessment data is not yet available for this container. It will be calculated when there are activities or issues to analyze.",
            noDocumentsToEvaluate: "No Documents Available",
            noDocumentsToEvaluateDesc: "Upload at least 2 documents to this container to enable cross-document validation.",
            needMoreDocs: "Need at least 2 documents",
            prepareClaim: "Prepare Claim",
            insuranceQuote: "Request Insurance Quote",
            searchIssues: "Search Past Issues",
            makeRecurring: "Make Recurring",
            duplicate: "Duplicate Container",
        },
        confirmDeleteContainer: {
            title: "Permanently Delete Container",
            message: "Are you sure you want to permanently delete container {{containerNumber}}? This action CANNOT be undone.",
            warning: "WARNING: This action is IRREVERSIBLE. The container and ALL related data will be permanently deleted: documents, events, issues, notes, orders, emails, and tracking history.",
            typeDeleteLabel: "Type DELETE to confirm:",
            cancel: "Cancel",
            delete: "Delete Permanently",
            success: "Container {{containerNumber}} has been permanently deleted.",
            error: "Failed to delete container. Please try again.",
        },
        confirmArchiveContainer: {
            title: "Archive Container",
            message: "Are you sure you want to archive container {{containerNumber}}?",
            warning: "The container will be hidden from the list but all data will be preserved. You can restore it later.",
            typeArchiveLabel: "Type ARCHIVE to confirm:",
            cancel: "Cancel",
            archive: "Archive Container",
            success: "Container {{containerNumber}} has been archived successfully.",
            error: "Failed to archive container. Please try again.",
        },
        tabs: {
            overview: "Overview",
            info: "Information",
            documents: "Documents",
            timeline: "Timeline",
            notes: "Notes",
            issues: "Issues",
            more: "More",
            moreHint: "timeline & notes",
        },
        info: {
            containerInfo: "Container Information",
            route: "Route",
            shipper: "Shipper",
            receiver: "Receiver",
            from: "From",
            to: "To",
            created: "Created",
            expandMap: "Expand map",
            collapseMap: "Collapse map",
            lastUpdate: "Last update",
            transportDetails: "Transport & Cargo Details",
            notes: "Notes & Instructions",
            sections: {
                vessel: "Vessel",
                container: "Container",
                cargo: "Cargo",
                references: "References",
                primaryParties: "Primary Parties",
                otherParties: "Other Parties (from documents)",
                shipmentSteps: "Shipment Progress",
                quickContacts: "Quick Contacts",
            },
            stakeholders: "Companies Involved",
            badges: {
                hazardous: "Hazardous",
                reefer: "Reefer",
            },
            phaseTimeline: {
                title: "Shipment progress",
                phases: {
                    draft: "Draft",
                    booked: "Booked",
                    in_transit: "In Transit",
                    arrived: "Arrived",
                    delivered: "Delivered",
                },
                activeDesc: {
                    draft: "Container created",
                    booked: "Booking confirmed with carrier",
                    inTransit: "Shipment in transit",
                    arrived: "Arrived at destination",
                    delivered: "Delivered to consignee",
                },
                stepsCount: "{{count}} steps",
                by: "By",
                subSteps: {
                    draft: "Draft",
                    draftDesc: "Container created",
                    bookingConfirmed: "Booking Confirmed",
                    bookingConfirmedDesc: "Shipment booking confirmed with carrier",
                    documentsReady: "Documents ready",
                    documentsReadyDesc: "Required documents submitted or linked",
                    vesselDeparted: "Vessel departed",
                    vesselDepartedDesc: "Vessel sailed from origin port",
                    inTransit: "In transit",
                    inTransitDesc: "Shipment on the way to destination",
                    arrivedAtPort: "Arrived at port",
                    arrivedAtPortDesc: "Vessel arrived at destination port",
                    customsClearance: "Customs clearance",
                    customsClearanceDesc: "Customs clearance in progress or completed",
                    deliveryConfirmed: "Delivery confirmed",
                    deliveryConfirmedDesc: "Cargo received and confirmed by consignee",
                },
            },
            fields: {
                status: "Status",
                progress: "Progress",
                riskLevel: "Risk Level",
                documentStatus: "Document Status",
                eta: "ETA",
                value: "Value",
                shippingCompany: "Shipping Company",
                country: "Country",
                lastTracked: "Last tracked",
                activeIssues: "Active Issues",
                vesselName: "Vessel Name",
                voyageNumber: "Voyage Number",
                carrier: "Carrier",
                receiver: "Receiver",
                containerType: "Container Type",
                cargoType: "Cargo Type",
                transportMode: "Transport Mode",
                incoterms: "Incoterms",
                description: "Description",
                hsCode: "HS Code",
                weight: "Weight",
                volume: "Volume",
                packages: "Packages",
                bookingNumber: "Booking No.",
                blNumber: "BL Number",
                purchaseOrder: "PO Number",
                serviceContract: "Service Contract",
                etd: "ETD",
                atd: "ATD",
                ata: "ATA",
                specialInstructions: "Special Instructions",
                customerNotes: "Customer Notes",
                consigneeId: "Consignee ID",
            },
        },
        tracking: {
            lastJsonCargoUpdate: "JSONCargo update",
            noJsonCargoUpdate: "No JSONCargo updates",
            lastEmailUpdate: "Email update",
            noEmailUpdate: "No email updates",
            createdFromEmail: "Created from imported email",
            setCarrierManually: "Set the carrier manually",
            carrierSelectPlaceholder: "Select carrier…",
            setCarrierConfirm: "Set carrier",
            carrierSetSuccess: "Carrier set — tracking refreshed",
            carrierSetError: "Could not update tracking",
        },
        documents: {
            title: "Documents",
            headers: {
                name: "Name",
                type: "Type",
                status: "Status",
                uploaded: "Uploaded",
                actions: "Actions",
            },
            actions: {
                view: "View",
                review: "Review",
                history: "History",
                download: "Download",
                delete: "Delete",
            },
            confirmDelete: {
                title: "Delete Document",
                message: "Are you sure you want to delete this document? This action cannot be undone.",
                cancel: "Cancel",
                delete: "Delete",
            },
            uploadInDevelopment: "Document upload functionality under development",
            uploadDocument: "Upload Document",
            discrepancies: {
                allCongruent: {
                    title: "All documents are consistent",
                    message: "Discrepancies have been resolved successfully. All attributes extracted from documents are now aligned and verified.",
                    resetButton: "Reset discrepancies",
                    viewTriage: "View Triage",
                },
                detected: {
                    title: "Possible discrepancies in document data",
                    message:
                        "We detected inconsistencies between some attributes extracted from this container's documents. We recommend proceeding with triage to verify and correct them.",
                    goToTriage: "Go to Document Triage",
                },
            },
        },
        timeline: {
            title: "Timeline Events",
            events: {
                containerCreated: "Container created",
                statusChanged: "Status changed",
                documentsUploaded: "Documents uploaded",
                progressUpdated: "Progress updated",
            },
            statusChangedFrom: "Status changed from",
            to: "to",
            documentsUploadedCount: "documents uploaded",
            progressUpdatedTo: "Progress updated to",
        },
        notes: {
            acknowledged: "Acknowledged",
            resolved: "Resolved",
            dismissed: "Dismissed",
            wontFix: "Won't Fix",
            inProgress: "In Progress",
            pendingInfo: "Pending Info",
            opened: "Opened",
            actionsTab: "Actions",
            noActionsYet: "No actions yet",
            noActionsDesc: "Document evaluations and issue actions will appear here",
            documentAnalysis: "Document Analysis",
            allClear: "All clear",
            viewResults: "View Results",
            findingsCount: "{{count}} findings",
            issuesCount: "{{count}} issues",
            edited: "edited",
        },
        evaluation: {
            stepReExtraction: "Re-running extraction\u2026",
            stepRequiredDocs: "Checking required documents\u2026",
            stepCrossRules: "Running cross-document rules\u2026",
            stepAiAnalysis: "AI cross-document analysis\u2026",
            selectedOf: "{{selected}} of {{total}} selected",
            willCheck: "Will check: missing docs \u00b7 cross-document rules \u00b7 AI analysis",
            requiredDocuments: "Required Documents",
            allRequiredPresent: "All required documents present",
            missing: "missing",
            crossCheckResults: "Cross-Check Results",
            crossChecksPassed: "All {{count}} cross-checks passed",
            passedAndFailed: "{{passed}} passed \u00b7 {{failed}} failed",
            aiObservations: "AI Observations",
            noDiscrepancies: "No discrepancies found",
            noData: "No data",
        },
    },
    triage: {
        title: "Document Triage",
        subtitle: "Container",
        resolveWithAI: "Resolve with AI",
        tabs: {
            matrix: "Matrix",
            visual: "Visual",
            raw: "Raw Data",
        },
        matrix: {
            attribute: "Attribute",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Document",
            check: "Check",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Highlight discrepancies",
        },
        modal: {
            title: "Resolving discrepancies with AI",
            analyzing: "Analyzing and correcting extracted attributes…",
            completed: "Resolution completed",
            allResolved: "All discrepancies have been resolved. You can close this window to see the updated results.",
            close: "Close",
        },
    },
    upload: {
        title: "Upload Documents",
        subtitle: "Upload documents for container",
        loading: "Loading...",
        notFound: {
            title: "Container not found",
            message: "The requested container does not exist.",
            backToList: "Back to list",
        },
        fileTooLarge: "File {fileName} is too large. Maximum 10MB allowed.",
        selectAtLeastOne: "Select at least one file to upload",
        documentType: "Document Type",
        uploadSelected: "Upload Selected",
        cancel: "Cancel",
        confirmUpload: "Confirm Upload",
        uploadInProgress: "Upload in progress",
        uploadCompleted: "Upload completed",
        returnToDocuments: "Return to Documents",
        removeFile: "Remove file",
        selectFiles: "Select Files",
        selectedFiles: "Selected Files",
        file: "file",
        files: "files",
        document: "document",
        documents: "documents",
        container: "Container",
        uploading: "Uploading...",
        uploadedSuccessfully: "Uploaded successfully",
        documentsUploadedSuccess: "Documents uploaded successfully!",
        documentsNowAvailable: "document(s) have been uploaded and are now available in the Documents section.",
        goToDocuments: "Go to Documents",
        confirmUploadTitle: "Confirm Document Upload",
        unknownTypeWarning: 'Some documents have type "Unknown Document". This means the system was unable to automatically identify the document type.',
        unknownTypeDocuments: "Documents with Unknown type:",
        proceedAnyway: "You can still proceed with the upload. Documents can be classified manually later.",
        proceedWithUpload: "Proceed with Upload",
    },
    worldMap: {
        title: "Live Tracking Hub",
        backToList: "Back to list",
        updateInfo: "The system checks and updates container positions periodically.",
        lastUpdate: "Last update",
        containerDetails: "Container Details",
        viewFullDetails: "View full details",
        showContainers: "Show Containers",
        showDetails: "Show details",
        hideToSeeRoute: "Hide to see route",
        containerList: "Containers on Map",
        containerSingular: "container",
        containerPlural: "containers",
        filterInProgress: "In transit",
        filterDelivered: "Arrived",
        filterAll: "All",
        lastKnownCoordinates: "Last known coordinates",
        positionRecordedAt: "Recorded: {{time}}",
        routeOrigin: "Departure (origin port)",
        routeDestination: "Arrival (destination port)",
        shipmentCarrier: "Carrier",
        shipmentVesselVoyage: "Vessel · Voyage",
        shipmentCargo: "Cargo",
        positionFixAt: "Position fix: {{time}}",
        aisLabel: "AIS",
        aisSpeedKn: "{{value}} kn",
        aisImo: "IMO {{imo}}",
        aisMmsi: "MMSI {{mmsi}}",
        aisCourse: "{{deg}}°",
        aisHeading: "Hdg {{deg}}°",
        aisDestination: "AIS destination: {{dest}}",
        aisEta: "AIS ETA: {{eta}}",
        sectionShipment: "Shipment details",
        sectionPosition: "Position & AIS",
    },
    receiver: {
        title: "Received Containers",
        subtitle: "Manage containers received from shippers",
        loading: "Loading containers...",
        searchPlaceholder: "Search by container ID, route or shipper...",
        shipperPlaceholder: "Filter by shipper",
        allShippers: "All shippers",
        description: "Complete list of received containers",
        headers: {
            containerId: "Container Ref.",
            shipper: "Shipper",
            route: "Route",
            shippingCompany: "Shipping Company",
            progress: "Progress",
            eta: "ETA",
            status: "Status",
            docStatus: "Doc Status",
            riskLevel: "Risk Level",
            value: "Value",
            actions: "Actions",
        },
        noContainers: {
            title: "No containers found",
            message: "Try modifying the search filters",
            emptyMessage: "No containers received yet",
        },
        viewDetails: "View Details",
        shipper: "Shipper",
    },
};
